import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import styled from "styled-components";

import MultiplyDivide from "../../applications/MultiplyDivide/Rating.js";
import Spelling from "../../applications/Spelling/Rating.js";
import Addition from "../../applications/Addition/Rating.js";
import Fractions from "../../applications/Fractions/Rating.js";
import Grammar from "../../applications/Grammar/Rating.js";
import Geometry from "../../applications/Geometry/Rating.js";
import Measurements from "../../applications/Measurements/Rating.js";
import PlaceValue from "../../applications/NumPlace/Rating.js";
import Statistics from "../../applications/Statistics/Rating.js";
import Numerals from "../../applications/Numerals/Rating.js";
import Algebra from "../../applications/Algebra/Rating.js"
import MTC from "../../applications/MTC/Rating.js"
import NumeracyIntervention from "../../applications/NumeracyIntervention/Rating.js";
import Phonics from "../../applications/Phonics/Rating.js"
import NumberSense from "../../applications/NumberSense/Rating.js"
import Ratios from "../../applications/Ratios/Rating.js"
import MathsVocab from "../../applications/MathsVocab/Rating.js";

import RatingStats from "../../hooks/useRatingStats.js"; // Import your hook

export default function Endless({ id, ...props }) {
  const game = useGame(id);
  const [gameStatus, setGameStatus] = useState(true);
  const ratings = RatingStats();
  


  if (ratings === undefined) {
    return <div>Loading ...</div>; // Or use your <Loading /> component
  }

  let initialLevel = 0;
  const userRatingObj = ratings.find(r => r.service_id == id);
  if (userRatingObj) {
    initialLevel = Math.round(userRatingObj.rating / 150);
    if (initialLevel > 10) initialLevel = 10;
  }


  const gameComponent = () => {
    switch (game.service_key) {
      case "timetables":
        return (
          <MultiplyDivide 
          onBack={() => setGameStatus(false)} 
          game={game} 
          gameType={game.game_type}
          endless = "endless"
          initialLevel={initialLevel}
          />
        );
      case "spelling":
        return (
          <Spelling
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
          />
        );
        case "addition":
          return(
            <Addition
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "fractions":
          return(
            <Fractions
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "grammar":
          return(
            <Grammar
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "geometry":
          return(
            <Geometry
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "measurement":
          return(
            <Measurements
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "numplace":
          return(
            <PlaceValue
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "statistics":
          return(
            <Statistics
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
          case "romannumerals":
          return(
            <Numerals
            onBack={() => setGameStatus(false)}
            game={game}
            gameType={game.game_type}
            endless = "endless"
            initialLevel={initialLevel}
            />
          )
        case "MTC":
          return (
            <MTC
              onBack={() => setGameStatus(false)}
              game={game}
              gameType={game.game_type}
              endless = "endless"
              initialLevel={initialLevel}
            />
          );
          case "algebra":
            return (
              <Algebra
                onBack={() => setGameStatus(false)}
                game={game}
                gameType={game.game_type}
                endless = "endless"
                initialLevel={initialLevel}
              />
            );
            case "assessnumeracy":
              return (
                <NumeracyIntervention
                  onBack={() => setGameStatus(false)}
                  game={game}
                  gameType={game.game_type}
                  endless = "endless"
                  initialLevel={initialLevel}
                />
              );
              case "phonics":
                return (
                  <Phonics
                    onBack={() => setGameStatus(false)}
                    game={game}
                    gameType={game.game_type}
                    endless = "endless"
                    initialLevel={initialLevel}
                  />
                );
                case "numbersense":
                  return (
                    <NumberSense
                      onBack={() => setGameStatus(false)}
                      game={game}
                      gameType={game.game_type}
                      endless = "endless"
                      initialLevel={initialLevel}
                    />
                  );
                  case "ratioprop":
                    return (
                      <Ratios
                        onBack={() => setGameStatus(false)}
                        game={game}
                        gameType={game.game_type}
                        endless = "endless"
                        initialLevel={initialLevel}
                      />
                    );
                    case "mvocab":
                      return (
                        <MathsVocab
                          onBack={() => setGameStatus(false)}
                          game={game}
                          gameType={game.game_type}
                          endless = "endless"
                          initialLevel={initialLevel}
                        />
                      );
      default:
        return null;
    }
  };

  return <div>{gameComponent()}</div>;
}
